// Libs
import React from 'react';
import { Box, Typography } from '@mui/material';

// Components
import Rating from '../../../../../Rating';
import OutOfStockLabel from '../../../../Labels/OutOfStockLabel';
import CountComponent from '../../CountComponent';
import OrderProductQtyLabels from '../../../../../Labels/OrderProductQtyLabels';
import ApprovalLabel from '../../../../../Labels/ApprovalLabel';
import ReportableIcon from '../../../../../Products/Card/ReportableIcon';

const DeviceView = ({
  product,
  order,
  orderItem,
  isRecurring,
  addressesCount,
  isMobileMode,
  isUnavailableForOrder,
  unavailableLabel,
  classes,
  cx,
  onOpenModal,
  totalOrdered,
}) => {
  const {
    rating: isRatable,
    reportable: isReportable,
    product_description: description,
    prepack_quantity,
    product_available_qty,
    size_vers: sizeVers,
  } = product || {};

  const renderMobileRating = () =>
    isMobileMode && isRatable && <Rating product={product} />;

  const renderTabletRating = () =>
    !isMobileMode &&
    isRatable && (
      <div className={classes.ratingContainer}>
        <Rating product={product} />
      </div>
    );

  const renderStock = () =>
    isUnavailableForOrder ? (
      <OutOfStockLabel label={unavailableLabel} device={{ isMobileMode }} />
    ) : (
      <Typography className={classes.qtyInfoText}>
        In Stock: {product_available_qty}
      </Typography>
    );

  const renderQtyLabels = () =>
    !isMobileMode && (
      <div className={classes.qtyInfoText}>
        <OrderProductQtyLabels
          orderItem={orderItem}
          addressesCount={addressesCount}
          isRecurring={isRecurring}
        />
      </div>
    );

  return (
    <>
      {renderMobileRating()}
      <Typography
        onClick={onOpenModal}
        className={classes.productDescription}
        width={isRecurring ? 'calc(100% - 40px)' : '100%'}
        data-testid="order-product-name">
        {description}
      </Typography>
      <Typography variant="textSm" className={classes.sizeVers}>
        {sizeVers}
      </Typography>
      {renderTabletRating()}
      <Box className={classes.qtyInfo}>
        {renderStock()}
        {renderQtyLabels()}
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={1}>
          <Typography className={cx(classes.qtyInfoText, classes.totalItems)}>
            {`Total Items Ordered: ${prepack_quantity ? totalOrdered : 'N/A'}`}
          </Typography>
          {isReportable && <ReportableIcon />}
        </Box>
      </Box>
      {isRecurring && !isUnavailableForOrder && (
        <Box className={classes.buttonContainer} marginTop="auto">
          <CountComponent
            isGridView
            product={product}
            orderItem={orderItem}
            order={order}
          />
        </Box>
      )}
      {!isRecurring && !isMobileMode && (
        <ApprovalLabel
          orderItemStatus={orderItem.status}
          approver={orderItem.approval?.approver}
          isModified={orderItem.qty_ordered !== orderItem.qty_approved}
          className={classes.approvalLabel}
        />
      )}
    </>
  );
};

export default DeviceView;
